import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Component } from '../../sdk/';

export class Categoria extends Component {
  constructor() {
    super({ services: ['TicketsApi', 'CategoriasApi'] });
  }
  state = {
    categorias: [],
  };
  static propTypes = {
    examples: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    this.CategoriasApi.find().then(data => {
      this.setState({ categorias: [...this.state.categorias, data] });
    });
  }
  render() {
    return <div className="examples-categoria">Page Content: examples/Tickets</div>;
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    examples: state.examples,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Categoria);



// WEBPACK FOOTER //
// ./src/features/examples/Categoria.js